// Cart drawer upsell carousel - added 2026-08-19, flash cue added 2026-08-19
//
// On mobile the upsell list becomes a horizontal scroll-snap carousel (see the
// max-width: 749px block in component-cart-drawer.css). This script handles two
// things:
//
//   1. Nav arrows. Shows the prev arrow when there is something to the left and
//      the next arrow when there is something to the right, and hides both
//      entirely when the track is not scrolling horizontally at all - which is
//      the case on desktop, where the list still stacks vertically.
//   2. A flash cue. Two seconds after the drawer opens, the next arrow pulses
//      its colors inverted twice to draw the eye to the swipe. The animation
//      itself lives in CSS and is only defined inside the mobile media query,
//      so adding the class on desktop does nothing.
//
// Everything is bound at the document level or via MutationObserver rather than
// to the elements themselves, because adding an item to the cart replaces the
// contents of .drawer__inner and script tags injected via innerHTML do not
// re-execute. Directly-bound listeners would be lost on the first cart update.

(function () {
	const TRACK = '.drawer__upsell-products'
	const NAV = '.drawer__upsell-nav'
	const NEXT = '.drawer__upsell-nav--next'
	const SLIDE = '.drawer__upsell-product'
	const FLASH = 'drawer__upsell-nav--flash'
	const FLASH_DELAY = 2000
	const EDGE = 2 // px tolerance, sub-pixel scroll positions never land on 0

	let flashTimer = null

	function isScrollable(track) {
		return track.scrollWidth - track.clientWidth > EDGE
	}

	function updateNav(track) {
		const wrapper = track.closest('.drawer__upsell-carousel')
		if (!wrapper) return

		const prev = wrapper.querySelector('.drawer__upsell-nav--prev')
		const next = wrapper.querySelector(NEXT)
		const scrollable = isScrollable(track)
		const maxScroll = track.scrollWidth - track.clientWidth

		if (prev) prev.hidden = !scrollable || track.scrollLeft <= EDGE
		if (next) next.hidden = !scrollable || track.scrollLeft >= maxScroll - EDGE
	}

	function updateAll() {
		document.querySelectorAll(TRACK).forEach(updateNav)
	}

	function step(track) {
		const slide = track.querySelector(SLIDE)
		if (!slide) return track.clientWidth
		const gap = parseFloat(getComputedStyle(track).columnGap) || 0
		return slide.getBoundingClientRect().width + gap
	}

	function flashNext() {
		document.querySelectorAll(NEXT).forEach(function (button) {
			if (button.hidden) return
			button.classList.remove(FLASH)
			void button.offsetWidth // reflow, so the animation restarts cleanly
			button.classList.add(FLASH)
		})
	}

	function scheduleFlash() {
		clearTimeout(flashTimer)
		flashTimer = setTimeout(flashNext, FLASH_DELAY)
	}

	document.addEventListener('click', function (event) {
		const button = event.target.closest(NAV)
		if (!button) return
		event.preventDefault()

		const wrapper = button.closest('.drawer__upsell-carousel')
		const track = wrapper && wrapper.querySelector(TRACK)
		if (!track) return

		const back = button.classList.contains('drawer__upsell-nav--prev')
		track.scrollBy({ left: back ? -step(track) : step(track), behavior: 'smooth' })
	})

	// scroll does not bubble, so listen in the capture phase
	document.addEventListener(
		'scroll',
		function (event) {
			const target = event.target
			if (target instanceof Element && target.matches(TRACK)) updateNav(target)
		},
		true
	)

	// drop the class once the pulses finish so it can fire again next open
	document.addEventListener('animationend', function (event) {
		const target = event.target
		if (target instanceof Element && target.classList.contains(FLASH)) {
			target.classList.remove(FLASH)
		}
	})

	window.addEventListener('resize', updateAll)
	document.addEventListener('DOMContentLoaded', updateAll)
	updateAll()

	// The drawer re-renders its own innerHTML on every cart change. #CartDrawer
	// itself survives, so observing it catches each re-render. Only childList is
	// observed, so the [hidden] attributes this script sets cannot retrigger it.
	const inner = document.getElementById('CartDrawer')
	if (inner && window.MutationObserver) {
		new MutationObserver(updateAll).observe(inner, {
			childList: true,
			subtree: true,
		})
	}

	// Dawn toggles .active on <cart-drawer> when the drawer opens and closes.
	// Watching only that element's class attribute (no subtree) means the class
	// changes this script makes to the buttons cannot retrigger it.
	const drawer = document.querySelector('cart-drawer')
	if (drawer && window.MutationObserver) {
		let wasActive = drawer.classList.contains('active')
		new MutationObserver(function () {
			const isActive = drawer.classList.contains('active')
			if (isActive && !wasActive) {
				updateAll()
				scheduleFlash()
			} else if (!isActive) {
				clearTimeout(flashTimer)
			}
			wasActive = isActive
		}).observe(drawer, { attributes: true, attributeFilter: ['class'] })
	}
})()
